(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentWorkItemAction', DocumentWorkItemAction);

    DocumentWorkItemAction.$inject = ['$resource', 'DateUtils'];

    function DocumentWorkItemAction ($resource, DateUtils) {
        var resourceUrl =  'api/document-work-item-actions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
